module.exports = __webpack_public_path__ + "static/details-8-94bdc76bd65ca6c7137b4e03c495fce5.jpg";